import { render, staticRenderFns } from "./CongestionSituation.vue?vue&type=template&id=eb3c050c&scoped=true"
import script from "./CongestionSituation.vue?vue&type=script&lang=js"
export * from "./CongestionSituation.vue?vue&type=script&lang=js"
import style0 from "./CongestionSituation.vue?vue&type=style&index=0&id=eb3c050c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3c050c",
  null
  
)

export default component.exports